/**
 * Hook usePermissions
 *
 * Acceso conveniente a permisos/rol del usuario en la empresa activa.
 * Wrapper sobre AuthContext (web y mobile comparten el mismo context).
 *
 * Uso:
 *   const { can, hasRole, userRole, activeEmpresaId } = usePermissions();
 *   {can('animals', 'delete') && <BotonEliminar/>}
 */

import { useAuth } from '../contexts/AuthContext';
import type { Action, Module, Role } from '../types/permissions';

export interface UsePermissionsResult {
  can: (module: Module, action: Action) => boolean;
  hasRole: (roles: Role[]) => boolean;
  userRole: Role | null;
  /** Admin del SITIO (profiles.role === 'admin'): foro, devtools, hoja de ruta. */
  isSiteAdmin: boolean;
  isAdmin: boolean;
  activeEmpresaId: string | null;
  permissionsLoading: boolean;
  refresh: () => Promise<void>;
}

export const usePermissions = (): UsePermissionsResult => {
  const { can, hasRole, userRole, isSiteAdmin, isAdmin, activeEmpresaId, permissionsLoading, refreshPermissions } =
    useAuth();
  return {
    can,
    hasRole,
    userRole,
    isSiteAdmin,
    isAdmin,
    activeEmpresaId,
    permissionsLoading,
    refresh: refreshPermissions,
  };
};
